<template>
  <div>
    <template v-if="videoTitle">
      <h2 class="video-title">
        {{ videoTitle }}
      </h2>
    </template>
    <div class="video-container">
      <iframe
        :src="videoUrl"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="video"
      />
    </div>
    <p
      v-if="videoCaption"
      class="video-caption"
    >
      {{ videoCaption }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'KfVideo',
  props: {
    videoId: {
      type: String,
      default: null,
    },
    videoTitle: {
      type: String,
      default: null,
    },
    videoCaption: {
      type: String,
      default: null,
    },
  },
  computed: {
    videoUrl() {
      return `https://www.youtube.com/embed/${this.videoId}`;
    }
  }
};
</script>

<style lang="postcss">
.video {
  @apply w-full h-full absolute top-0 left-0;

  &-container {
    @apply w-full h-0 relative;
    padding-top: 56.25%;
  }

  &-caption {
    @apply text-gray-300 text-sm mt-3 mb-0;
  }

  &-title {
    @apply text-4xl text-secondary-alpha text-left mb-10;

    @screen md {
     @apply text-center;
    }
  }
}
</style>






